<form [formGroup]="form">
    <div class="flex flex-col bg-neutral-200 rounded-lg p-5 justify-between">
        <section>
            <p class="font-medium">Cevo Availability:</p>
            <div class="inline-flex rounded-md mb-6" role="group">
                <label
                    for="available"
                    tabindex="0"
                    (keydown.enter)="form.controls.isAvailable.setValue(true)"
                    [class]="
                        form.controls.isAvailable.value === true
                            ? 'bg-primary-100 text-primary-800'
                            : 'text-tertiary-900 hover:bg-tertiary-100'
                    "
                    class="relative flex items-center px-5 py-2 text-sm font-medium border rounded-l-md cursor-pointer border-tertiary-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary-700"
                >
                    <input
                        id="available"
                        type="radio"
                        formControlName="isAvailable"
                        [value]="true"
                        class="sr-only"
                        tabindex="-1"
                    />
                    <mat-icon class="scale-75 me-2" aria-hidden="true"
                        >check</mat-icon
                    >
                    Yes
                </label>

                <label
                    for="unavailable"
                    tabindex="0"
                    (keydown.enter)="form.controls.isAvailable.setValue(false)"
                    [class]="
                        form.controls.isAvailable.value === false
                            ? 'bg-error-100 text-error-800'
                            : 'text-tertiary-900 hover:bg-tertiary-100'
                    "
                    class="relative inline-flex items-center px-5 py-2 text-sm font-medium border rounded-r-md cursor-pointer border-tertiary-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary-700"
                >
                    <input
                        id="unavailable"
                        type="radio"
                        formControlName="isAvailable"
                        [value]="false"
                        class="sr-only"
                        tabindex="-1"
                    />
                    <mat-icon class="scale-75 me-2">close</mat-icon>
                    No
                </label>
            </div>
        </section>
        <section class="flex flex-col">
            <div class="flex items-center justify-between mb-2">
                <div class="flex flex-col">
                    <p class="font-medium !m-0">
                        Scheduled Cevo Unavailability:
                    </p>
                    <p class="text-xs font-normal text-tertiary-600 !m-0">
                        Select date(s) to be marked unavailable
                    </p>
                </div>
            </div>
            <mat-form-field>
                <mat-date-range-input
                    (keyup)="picker.open()"
                    (click)="picker.open()"
                    [rangePicker]="picker"
                >
                    <input
                        matStartDate
                        formControlName="unavailabilityStartDate"
                        placeholder="Start Date"
                    />
                    <input
                        matEndDate
                        formControlName="unavailabilityEndDate"
                        placeholder="End Date"
                    />
                </mat-date-range-input>
                <mat-datepicker-toggle
                    matIconSuffix
                    [for]="picker"
                ></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
                <mat-hint
                    align="end"
                    class="text-primary-700 font-medium cursor-pointer text-sm"
                    (click)="clearDates()"
                    >Clear Dates</mat-hint
                >
            </mat-form-field>
        </section>
    </div>
</form>
